import { type IAvailabilityReason } from "@/interfaces/api/availability-reason.interface.ts"
import { BaseRepository } from "@/repositories/base-repository"

export class AvailabilityReasonRepository extends BaseRepository<IAvailabilityReason> {
  resourcePath = "core/availability-reasons"
}
